var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-column"},[_c('div',{staticClass:"column-title"},[_vm._v(_vm._s(_vm.$t('teams.single')))]),(_vm.hash)?_c('BaseTeamLink',{attrs:{"hash":_vm.hash}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }